var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneAlternative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fillOpacity: 0.1,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8135 30.1365L28.4714 28.9492C28.0707 28.7462 27.5545 28.8501 27.2083 29.204C26.8174 29.6039 26.3218 30.1077 25.8978 30.5406C25.75 30.6912 25.5399 30.7561 25.3524 30.7052C24.6207 30.5052 23.4051 29.9665 22.2397 28.8139C21.047 27.6341 20.4977 26.3877 20.297 25.6494C20.2457 25.4615 20.3114 25.2507 20.4623 25.1032L21.7978 23.7935C22.1517 23.4477 22.2556 22.9315 22.0525 22.5304L20.8657 20.1883C20.6312 19.7258 20.0609 19.5507 19.554 19.7966C18.7107 20.2054 17.5363 21.034 17.0866 22.5864C16.8645 23.7313 16.8353 27.5819 20.0057 30.8277C23.2802 34.1805 27.0706 34.1326 28.4157 33.9156C29.3279 33.651 29.99 33.1372 30.4638 32.5867",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9287 18.6367C23.4823 18.6717 24.0031 18.9923 24.268 19.524C24.5294 20.0488 24.4773 20.6478 24.1832 21.1084",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7656 16.3352C24.9392 16.4087 26.0428 17.0887 26.6049 18.2164C27.1592 19.3285 27.0484 20.5982 26.4244 21.5742",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5718 13.9997C26.3829 14.1133 28.0856 15.162 28.953 16.9028C29.808 18.6182 29.6373 20.5772 28.6745 22.083",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAlternative);
export default __webpack_public_path__ + "static/media/phone-alternative.e173e215849d7bfa62c45420c3c0b6d7.svg";
export { ForwardRef as ReactComponent };